import { submitEvent, submitEventMerge, submitMerge } from "@otto-ec/tracking-bct";
import type { Detailview } from "../Detailview";
import { type TrackingFeatureStatus, type TrackingActivationResponse, createTrackingEvent, createTrackingEventPayload } from "./FeatureTrackingPayload";

export class TrackingService {
	private trackingStatus = new Map<string, TrackingFeatureStatus>();

	sendDetailviewBenefitLoadedEvent(benefit: Detailview, eventMergeId: string | null) {
		const featureTracking = createTrackingEventPayload(benefit, "loaded");
		this.trackingStatus.set(benefit.variationId, "loaded");

		if (eventMergeId && eventMergeId.length > 0) {
			submitEventMerge(eventMergeId, {}, createTrackingEvent("change", featureTracking));
		} else {
			submitMerge({}, featureTracking);
		}
	}

	sendDetailviewBenefitMergeEvent(benefit: Detailview, eventMergeId: string) {
		/*                                                                                                                                                                                 */
		const benefitTrackingStatus = this.trackingStatus.get(benefit.variationId) ?? "loaded";
		const featureTracking = createTrackingEventPayload(benefit, benefitTrackingStatus);
		submitEventMerge(eventMergeId, {}, createTrackingEvent("add", featureTracking));
	}

	sendDetailviewBenefitSwipeEvent(benefit: Detailview, response: TrackingActivationResponse): string {
		const eventMergeId = this.generateRandomString(10);

		const partnerFeatureTracking = createTrackingEventPayload(benefit, "clicked", response);
		this.trackingStatus.set(benefit.variationId, "clicked");
		submitEventMerge(eventMergeId, {}, createTrackingEvent("swipe", partnerFeatureTracking));
		return eventMergeId;
	}

	sendDetailviewBenefitClickEvent(benefit: Detailview) {
		const partnerFeatureTracking = createTrackingEventPayload(benefit, "clicked");
		this.trackingStatus.set(benefit.variationId, "clicked");
		submitEvent({}, createTrackingEvent("click", partnerFeatureTracking));
	}

	private generateRandomString(length: number): string {
		const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join("");
	}
}
